export const DEFAULT_SUBJECT_ENCODING = '4-2-2-2'
export const ROOT_SUBJECT_CODE_LENGTH = 4
export const MAX_SUBJECT_LEVEL = 9

function normalizeSegments(segments) {
	if (!Array.isArray(segments) || !segments.length) {
		return [ROOT_SUBJECT_CODE_LENGTH, 2, 2, 2]
	}
	return segments
		.map(item => parseInt(item, 10))
		.filter(item => !Number.isNaN(item) && item > 0)
}

export function parseSubjectEncoding(encoding) {
	let source = encoding
	if (Array.isArray(encoding)) {
		source = encoding.join('-')
	}
	let segments = String(source || DEFAULT_SUBJECT_ENCODING)
		.split('-')
		.map(item => parseInt(String(item).trim(), 10))
		.filter(item => !Number.isNaN(item) && item > 0)
	if (!segments.length) {
		segments = [ROOT_SUBJECT_CODE_LENGTH, 2, 2, 2]
	}
	segments[0] = ROOT_SUBJECT_CODE_LENGTH
	return segments.slice(0, MAX_SUBJECT_LEVEL)
}

export function stringifySubjectEncoding(encoding) {
	return parseSubjectEncoding(encoding).join('-')
}

export function getSubjectLevelCount(encoding) {
	return parseSubjectEncoding(encoding).length
}

export function getSubjectSegmentLength(encoding, level) {
	let segments = parseSubjectEncoding(encoding)
	return segments[level - 1] || 0
}

export function getSubjectCumulativeLength(encoding, level) {
	let segments = parseSubjectEncoding(encoding)
	let total = 0
	for (let i = 0; i < Math.min(level, segments.length); i++) {
		total += segments[i]
	}
	return total
}

export function buildSubjectLevelOptions(encoding, includeAll = false) {
	let count = getSubjectLevelCount(encoding)
	let options = []
	for (let i = 1; i <= count; i++) {
		options.push({key: i, title: `${i}级`})
	}
	if (includeAll) {
		options.push({key: 0, title: '全部'})
	}
	return options
}

export function matchesSubjectEncoding(code, encoding) {
	let value = String(code || '').trim()
	if (!/^\d+$/.test(value)) {
		return false
	}
	let segments = parseSubjectEncoding(encoding)
	let total = 0
	for (let i = 0; i < segments.length; i++) {
		total += segments[i]
		if (value.length === total) {
			return true
		}
	}
	return false
}

export function convertSubjectCodeByEncoding(code, fromEncoding, toEncoding) {
	let value = String(code || '').trim()
	if (!/^\d+$/.test(value)) {
		return value
	}
	let sourceSegments = normalizeSegments(parseSubjectEncoding(fromEncoding))
	let targetSegments = normalizeSegments(parseSubjectEncoding(toEncoding))
	let parts = []
	let start = 0
	for (let i = 0; i < sourceSegments.length; i++) {
		let len = sourceSegments[i]
		if (value.length <= start) {
			break
		}
		parts.push(value.substring(start, Math.min(value.length, start + len)))
		start += len
	}
	let levelCount = Math.min(parts.length, targetSegments.length)
	for (let i = 0; i < levelCount; i++) {
		let item = parts[i]
		let len = targetSegments[i]
		if (item.length < len) {
			item = item.padStart(len, '0')
		} else if (item.length > len) {
			item = item.substring(item.length - len)
		}
		parts[i] = item
	}
	return parts.slice(0, levelCount).join('')
}
